const getDefaultRoute = (router) => {
  const defaultRoute = router.getRoutes().find(route => route.meta.default)
  if (defaultRoute) return defaultRoute
  return router.getRoutes().find(route => !route.name.includes('root'))
}

export { getDefaultRoute }
